export default "__VITE_ASSET__BubB8wIY__"